import "./BaseTable.scss";
import AutoSizer from "react-virtualized-auto-sizer";
import NoDataView from "../NoDataView";
import { Table, TablePaginationConfig, TableProps } from "antd";

interface BaseTableProps<T> extends TableProps<T> {
  summaryHeight?: number;
}

function BaseTable<T>(props: BaseTableProps<T>) {
  const { className, summaryHeight = 0, ...rest } = props;

  const scrollHeightWithEmptyData = (height: number) => {
    return height - 90 - summaryHeight;
  };

  return (
    <div className="h-100 w-100">
      <AutoSizer>
        {({ height, width }) => {
          const tableHeight = height - 40 - summaryHeight;
          return (
            <div
              style={{
                height: height,
                width: width,
              }}
            >
              <Table
                className={`acc-base-table-wrapper ${className}`}
                scroll={{
                  y: tableHeight,
                  x: width,
                }}
                style={{
                  height: height - 40,
                }}
                tableLayout="auto"
                bordered
                locale={{
                  emptyText: () => {
                    return (
                      <div
                        style={{
                          justifyContent: "center",
                          height: scrollHeightWithEmptyData(height),
                          alignItems: "center",
                        }}
                        className={"w-100 flex"}
                      >
                        <NoDataView />
                      </div>
                    );
                  },
                }}
                {...rest}
              ></Table>
            </div>
          );
        }}
      </AutoSizer>
    </div>
  );
}

export default BaseTable;
